'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = require('../../util/helpers');

/* @vue/component */
exports.default = {
    name: 'v-card-media',
    props: {
        contain: Boolean,
        height: {
            type: [Number, String],
            default: 'auto'
        },
        src: {
            type: String
        }
    },
    render: function render(h) {
        var data = {
            'class': 'v-card__media',
            style: {
                height: (0, _helpers.convertToUnit)(this.height)
            },
            on: this.$listeners
        };
        var children = [];
        if (this.src) {
            children.push(h('div', {
                'class': 'v-card__media__background',
                style: {
                    background: 'url("' + this.src + '") center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
                }
            }));
        }
        children.push(h('div', {
            'class': 'v-card__media__content'
        }, this.$slots.default));
        return h('div', data, children);
    }
}; // Helpers
//# sourceMappingURL=VCardMedia.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/VCard/VCardMedia.js
// module id = BzEx
// module chunks = 0